import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


//获取列表数据
export const looklist = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/looklist', qs.stringify(params))
}
//待入库
export const updatebadparts = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/updatebadparts', qs.stringify(params))
}
//待出库
export const badpartscount = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/badpartscount', qs.stringify(params))
}//已办结
export const completedcount = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/completedcount', qs.stringify(params))
}
export const completeddetail= (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/completeddetail', qs.stringify(params))
}


export const listInit= (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/listInit', qs.stringify(params))
}
export const inorder = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/inorder', qs.stringify(params))
}
export const outorder = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/outorder', qs.stringify(params))
}

export const updatestoredetail = (params) => {
  return axios.post(root + '/warehouse/jxcstoreformdetail/update', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcstoreformdetail.js